import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Subject, takeUntil } from 'rxjs';

import { TranslateModule } from '@ngx-translate/core';

import { ComposeService } from '../../../../services/compose.service';
import { SvgIconComponent } from 'src/app/ui/svg-icon/svg-icon.component';

/**
 * Floating bar shown when compose panels are minimized.
 * Displays the count and restores all panels on click.
 */
@Component({
  selector: 'app-compose-minimized-bar',
  standalone: true,
  templateUrl: './compose-minimized-bar.component.html',
  styleUrls: ['./compose-minimized-bar.component.scss'],
  imports: [CommonModule, MatIconModule, MatTooltipModule, TranslateModule, SvgIconComponent],
})
export class ComposeMinimizedBarComponent implements OnInit, OnDestroy {
  minimizedCount = 0;

  private destroy$ = new Subject<void>();

  constructor(private composeService: ComposeService) {}

  ngOnInit(): void {
    this.composeService.panels.pipe(takeUntil(this.destroy$)).subscribe((panels) => {
      this.minimizedCount = panels.filter((p) => p.minimized).length;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  restore(): void {
    this.composeService.restoreAllMinimized();
  }
}
